export const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mykoddvy';
